import React, { useEffect, useState } from 'react'
import * as bie from "react-bootstrap";
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import allowNumbersOnly from '../../CommonUtils/CommonValidations';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as Yup from 'yup';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import { failureAlert, InfoAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { FaCheck, FaTimes, } from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';
import { FaHandPointRight } from "react-icons/fa";

export default function RevertBackService() {
    const userId = (sessionStorage.getItem('user_id'));
    const [currentStep, setCurrentStep] = useState(0);
    const [ffcacurrentStep, setffcaCurrentStep] = useState(0);
    const [statusObj, setStatusObj] = useState({});
    const [timer, setTimer] = useState(0); // Timer in seconds
    const [status, setStatus] = useState("");
    const [showtable, setShowTable] = useState(null);
    const [clgDetails, setclgDetails] = useState([]);
    const [revertclgdtls, setRevertclgdtls] = useState([]);


    function GetCollegeData(code) {
        setverify(false);
        setsubmit(false);

        RevertFormik.setFieldValue("otp", '');
        RevertFormik.setFieldValue("type", '');
        RevertFormik.setFieldValue("remarks", '');


        let url = config.url.API_URL + `getClgDetails/` + RevertFormik?.values?.collCode;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status == true) {
                setclgDetails(res?.data?.getClgDetails);
                setRevertclgdtls(res?.data?.getRevertedDetails);
                setShowTable(true);

            } else {
                setShowTable(true);
                setStatus("*** No Data Found ***")
                setclgDetails([]);
            }
        })
    }
    const RevertBackValidation = Yup.object({
        type: Yup.string().required(ERROR_MSG).nullable(),
        remarks: Yup.string().required(ERROR_MSG).nullable(),
    })
    const RevertFormik = useFormik({
        initialValues: {
            otp: "",
            collCode: "",
            type: "",
            userId: userId,
            officername: "",
            mobileno: "",
            remarks: ""


        },
        enableReinitialize: true,
        validationSchema: RevertBackValidation,
        onSubmit: (values, { resetForm }) => {

            values.collCode = parseInt(values.collCode, 10);
            const finalValues = {
                ...values,
                officername: clgDetails[0]?.dean_name || "",
                // mobileno: clgDetails[0]?.dean_mobile || ""
                mobileno: 6281021090,

            };

            console.log("Final submitted values:", finalValues);

            // Swal.fire({
            //     text: 'Are you sure you want to Revert Back?',
            //     icon: 'warning',
            //     showCancelButton: true,
            //     confirmButtonText: 'Yes, Revert it!',
            //     cancelButtonText: 'No, cancel!',
            //     backdrop: false,
            // }).then((result) => {
            //     if (result.isConfirmed) {
            const url = `${config.url.API_URL}reset-affiliation`;
            CommonAxiosPost(url, finalValues).then((res) => {
                if (res?.data?.scode === '01') {
                    successAlert2(res?.data?.sdesc);
                    // GetData();
                    setStatus("");
                    setclgDetails([]);
                    setShowTable(false);
                    setModal(false);
                    RevertFormik.setFieldValue("collCode", '');


                } else {
                    failureAlert("Failed to submit");
                }
            });

        }
    })

    const [showverify, setverify] = useState('');
    function GetOtp() {
        // let url = config.url.API_URL + `getOtpDetails/` + clgDetails[0]?.dean_mobile + "/" + RevertFormik?.values?.collCode; 8096553869
        let url = config.url.API_URL + `getOtpDetails/` + 6281021090 + "/" + RevertFormik?.values?.collCode;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status == true) {
                successAlert2(res?.data?.sdesc)
                setverify(true)
                setsubmit(false)
                setTimer(60);

            } else {

            }
        })
    }
    const [showsubmit, setsubmit] = useState(null);
    function OtpVerify() {
        if (!RevertFormik?.values?.otp) {
            InfoAlert("plese enter Otp")
        }
        else {
            // let url = config.url.API_URL + `verifyOtp/` + clgDetails[0]?.dean_mobile + "/" + RevertFormik?.values?.otp;
            let url = config.url.API_URL + `verifyOtp/` + 6281021090 + "/" + RevertFormik?.values?.otp;


            CommonAxiosGet(url).then((res) => {
                if (res?.data?.status == true) {
                    successAlert2(res?.data?.sdesc)
                    setsubmit(true)
                } else {
                    failureAlert(res?.data?.sdesc)

                }
            })
        }
    }
    const FFCAOamdc = {
        titles: [
            "College Section",
            "FFCA Section",
            "Dean Section",
            "Registrar Section",

        ],

        fieldMap: {
            college_status: 0,
            ffca_status: 1,
            cdc_status: 2,
            ao_status: 3,

        }
    };
    const FFCADashboardFlow = FFCAOamdc;
    function computeCurrentStep(status, { fieldMap, titles }) {
        for (const [field, idx] of Object.entries(fieldMap)) {
            if (status[field] !== 'Done') {
                return idx + 1;
            }
        }
        return titles.length;
    }


    function GetData(collcode) {
        CommonAxiosGet(`${config.url.API_URL}collegeresetstatus/${collcode}`)
            .then(res => {
                if (res?.data?.scode === '01' && res.data.data?.[0]) {
                    const obj = res.data.data[0];
                    setStatusObj(obj);
                    setCurrentStep(computeCurrentStep(obj, FFCADashboardFlow));
                } else {
                    setStatusObj({});
                    setCurrentStep(0);
                }
            })
            .catch(() => {
                setStatusObj({});
                setCurrentStep(0);
            });
    }
    useEffect(() => {
        let interval = null;

        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [timer]);

    function getRevertBackOptions(statusObj) {
        const options = [];

        // if (statusObj?.college_status === 'Done') {
        //     options.push('College');
        // }


        if (statusObj?.ffca_status === 'Done') {
            options.push('ffca');
        }

        if (statusObj?.cdc_status === 'Done') {
            options.push('dean');
        }

        if (statusObj?.ao_status === 'Done') {
            options.push('registrar');
        }

        return options;
    }

    const revertOptions = getRevertBackOptions(statusObj);
    const [modal, setModal] = useState(false)

    return (
        <>

            <Modal show={modal} onHide={() => setModal(false)} centered backdrop="static" >
                <FormikProvider value={RevertFormik}>
                    <Form onChange={RevertFormik.handleChange} onSubmit={RevertFormik.handleSubmit}>
                        <Modal.Header closeButton style={{ backgroundColor: "#795A1D", color: "brown" }}>
                            {/* <Modal.Title >OTP Verification</Modal.Title> */}
                            <Modal.Title
                                style={{
                                    borderLeft: '4px solid #cf9831ff', // <- custom color (orange here)
                                    paddingLeft: '12px',
                                    fontWeight: 'bold',
                                    fontSize: '18px',
                                    color: '#612904ff' // text color, assuming dark header
                                }}
                            >
                                OTP Verification
                            </Modal.Title>

                        </Modal.Header>

                        <Modal.Body>
                            <div className="mb-3">
                                <strong>Dean Mobile:</strong> 6281021090
                                {/* {clgDetails[0]?.dean_mobile} */}
                            </div>

                            {!showverify && (
                                <div className="mb-3">
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => {
                                            setModal(true);
                                            GetOtp();
                                        }}
                                    >
                                        Get OTP
                                    </Button>
                                </div>
                            )}

                            {showverify && !showsubmit && (
                                <>
                                    <div className="mb-3">
                                        <Field
                                            type="text"
                                            name="otp"
                                            placeholder="Enter OTP"
                                            className="form-control form-control-sm"
                                            maxLength="6"
                                        />
                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <span className="text-muted" style={{ fontSize: '14px' }}>
                                                {timer > 0 ? ` OTP will Expire in ${timer} sec` : 'OTP Expired'}
                                            </span>

                                            <button type='button'
                                                style={{
                                                    color: "blue",
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                    cursor: "pointer"
                                                }}
                                                onClick={() => {
                                                    RevertFormik?.setFieldValue("otp", '');
                                                    GetOtp();
                                                }}
                                            >
                                                Didn't receive OTP? Resend
                                            </button>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <Button
                                            variant="secondary"
                                            size="sm"
                                            onClick={OtpVerify}
                                        >
                                            Verify OTP
                                        </Button>
                                    </div>
                                </>
                            )}

                            {showsubmit && (
                                <div className="mb-3">
                                    <Button
                                        type="submit"
                                        variant="success"
                                        size="sm"
                                        className="float-end"
                                    >
                                        Submit
                                    </Button>
                                </div>
                            )}
                        </Modal.Body>
                    </Form>
                </FormikProvider>
            </Modal>
            <CommonFormHeading heading="Revert Back Service" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">

                    <FormikProvider value={RevertFormik}>
                        <Form onChange={RevertFormik.handleChange} onSubmit={RevertFormik.handleSubmit} className='affl-form'>

                            <bie.Row className="px-2 pt-3 mb-3">

                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                    <label className='mb-1'>
                                        Enter College Code :
                                    </label>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>

                                    <Field type="text" name="collCode" className="form-control" onKeyPress={(e) => { allowNumbersOnly(e) }}
                                        maxLength={5}
                                        onChange={() => {
                                            setStatus("");
                                            setclgDetails([]);
                                            setShowTable(false);
                                        }} />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} >
                                    <button type="button" className="btn btn-success "
                                        onClick={() => {
                                            const code = RevertFormik?.values?.collCode || '';
                                            if (code?.length === 5) {
                                                GetCollegeData(code);
                                                GetData(code);
                                            }
                                            else {
                                                InfoAlert('Invalid college code: must be exactly 5 Digits.');
                                            }
                                        }}>
                                        Get Data
                                    </button>
                                </bie.Col>
                                <br />


                            </bie.Row>

                            {showtable === true && clgDetails !== "No data found" && clgDetails?.length > 0 ? (<>
                                <bie.Row className="px-2 pt-3 mb-3">
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="mb-0">College Details</h1></div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table" style={{ width: "100%" }} role="presentation"
                                            aria-hidden="true">
                                            <tbody>

                                                <tr>

                                                    <td className='text-left' style={{ fontWeight: "bold", fontSize: "15px" }}>  University Name : </td>
                                                    <td className='text-left' style={{ fontSize: "16px" }}>  {clgDetails[0]?.ub_name}   </td>
                                                </tr>
                                                <tr>

                                                    <td className='text-left' style={{ fontWeight: "bold", fontSize: "15px" }}>  College Code:  </td>
                                                    <td className='text-left' style={{ fontSize: "16px" }}>  {clgDetails[0]?.coll_code}   </td>
                                                </tr>
                                                <tr>

                                                    <td className='text-left' style={{ fontWeight: "bold", fontSize: "15px" }}>  Institution Name: </td>
                                                    <td className='text-left ' style={{ fontSize: "16px" }}>  {clgDetails[0]?.inst_name}   </td>
                                                </tr>
                                                <tr>  <td className='text-left' style={{ fontWeight: "bold", fontSize: "15px" }}>  College Address: </td>
                                                    <td className='text-left' style={{ fontSize: "16px" }}>  {clgDetails[0]?.dist_name}-{clgDetails[0]?.mandal_name}-{clgDetails[0]?.village_name}-{clgDetails[0]?.inst_street} </td></tr>



                                                {/* <tr>

                                                    <td className='text-left' style={{ fontWeight: "bold", fontSize: "15px" }}>  Dean Name:</td>
                                                    <td className='text-left' style={{ fontSize: "16px" }}>    {clgDetails[0]?.dean_name}   </td>
                                                </tr>
                                                <tr>

                                                    <td className='text-left' style={{ fontWeight: "bold", fontSize: "15px" }}>  Dean Mobile: </td>
                                                    <td className='text-left' style={{ fontSize: "16px" }}>   {clgDetails[0]?.dean_mobile}  </td>
                                                </tr> */}

                                            </tbody>

                                        </table>
                                    </div>
                                    {/* </>)} */}

                                </bie.Row>


                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0"> Application status</h1></div>
                                <bie.Row>
                                    <bie.Container fluid className="pt-5" >
                                        <div className="horizontal-stepper-wrapper" >
                                            {FFCADashboardFlow?.titles?.map((title, idx) => {
                                                const ffcaStepIndex = idx + 1;
                                                const fieldKey = Object.keys(FFCADashboardFlow?.fieldMap)
                                                    .find(key => FFCADashboardFlow?.fieldMap[key] === idx);
                                                const isDone = statusObj[fieldKey] === 'Done' ? "Done" : "Not Done";
                                                const isActive = ffcaStepIndex === ffcacurrentStep;

                                                return (
                                                    <div key={idx} className="stepper-item" style={{ width: "100%" }}>
                                                        <div className={`step-icon ${isDone == "Done" ? 'completed' : isActive ? 'active' : 'pending'}`}>
                                                            {ffcaStepIndex}
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className={`step-title ${isDone === "Done" ? 'label-done' : ''} ${isActive ? 'active-label' : ''}`}
                                                            onClick={() => setffcaCurrentStep(ffcaStepIndex)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {title}
                                                        </button>
                                                        <div className="step-badge">
                                                            <bie.Badge bg={isDone === "Done" ? "success" : isDone === "Not Done" ? "danger" : ""}>
                                                                {isDone === "Done" ? <FaCheck className="me-1" /> : isDone === "Not Done" ? <FaTimes className="me-1" /> : ""}
                                                                {isDone === "Done" ? 'Done' : isDone === "Not Done" ? 'Not Done' : ""}
                                                            </bie.Badge>
                                                        </div>
                                                        {idx !== FFCADashboardFlow?.titles?.length - 1 && (
                                                            <div className={`step-line-horizontal ${isDone == "Done" ? 'line-completed-horizontal' : ''}`}></div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </bie.Container>
                                </bie.Row>


                                <br />
                                <br />

                                <div className="jumbotron mt20 form-card-jnb pt-4 pb-4" style={{ marginTop: "5px" }} >
                                    <bie.Row>

                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                            <bie.InputGroup>
                                                <strong className='px-3'>
                                                    Revert Back to?
                                                </strong>&emsp;

                                                <Field as="select" name="type" className="form-control form-control-sm">
                                                    <option value="">---select---</option>
                                                    {/* {revertOptions.includes('College') && <option value="ffca">College</option>} */}

                                                    {revertOptions?.includes('ffca') && <option value="ffca">FFCA</option>}
                                                    {revertOptions?.includes('dean') && <option value="dean">Dean</option>}
                                                    {revertOptions?.includes('registrar') && <option value="registrar">Registrar</option>}
                                                </Field>
                                            </bie.InputGroup>

                                            <ErrorMessage name="type" component="div" className="text-error" />

                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5} >
                                            <bie.InputGroup>
                                                <strong>
                                                    Enter Remarks:
                                                </strong>&emsp;

                                                <Field as="textarea" name="remarks" className="form-control form-control-sm " placeholder="Enter Remarks" maxLength="300"
                                                    cols={240}
                                                    rows={90}
                                                />
                                            </bie.InputGroup>

                                            <ErrorMessage name="remarks" component="div" className="text-error" />
                                        </bie.Col>
                                    </bie.Row>
                                    <bie.Row className='mt-3'>
                                        <bie.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5} >
                                            <strong className="mx-3">Dean Name:</strong>
                                            {clgDetails[0]?.dean_name}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                            <strong>Dean Mobile:</strong> 6281021090
                                            {/* {clgDetails[0]?.dean_mobile} */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm"
                                                onClick={() => {
                                                    if (!RevertFormik.values.type) {
                                                        InfoAlert("Please select a revert back option.");
                                                        return;
                                                    }
                                                    if (!RevertFormik?.values?.remarks) {
                                                        InfoAlert("Please Enter Remarks")
                                                        return;
                                                    }
                                                    setModal(true);
                                                }}
                                            >
                                                <FaHandPointRight size={20} /> &nbsp;
                                                Otp Verification
                                            </button>
                                        </bie.Col>
                                    </bie.Row>

                                </div>

                                {revertclgdtls !== "No data found" && revertclgdtls !== undefined && (<>
                                    <div className="inner-herbpage-service-title-sub mt-5">
                                        <h1 className="mb-0">Previous Log</h1></div>
                                    <div className="table-responsive px-0">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table" role="presentation"
                                            aria-hidden="true">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Acedemic year</th>
                                                    <th>Reverted by</th>
                                                    <th> Reverted Stage</th>
                                                    <th>Mobile No</th>
                                                    <th>Remarks</th>
                                                    {/* <th>No.of Times Reverted</th> */}
                                                    <th> Last Reverted Time</th>

                                                </tr>
                                            </thead>

                                            <tbody style={{ textAlign: "center" }}>
                                                {revertclgdtls !== undefined && revertclgdtls !== "No data found" &&
                                                    revertclgdtls.map((data, i) => {
                                                        return (
                                                            <>
                                                                <tr>
                                                                    <td>{i + 1}</td>
                                                                    <td className='text-left'> {data?.ac_year} </td>
                                                                    <td className='text-left'> {data?.revert_by || "-"} </td>
                                                                    <td className='text-left'> {data?.revert_action} </td>
                                                                    <td> {data?.revert_mobile || "-"} </td>
                                                                    <td className='text-left'>{data?.remarks || "-"}</td>
                                                                    {/* <td> {data?.revertedcount} </td> */}
                                                                    {/* <td> {data?.revert_time} </td> */}
                                                                    <td>
                                                                        {data?.last_revert_time
                                                                            ? new Date(data.last_revert_time).toLocaleString() // local date and time string
                                                                            : '-'}
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        );
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                </>)}



                            </>) : (<center className="text-danger h6" >{status} </center>)}
                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container >

        </>
    )
}
